/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "empermissions": {
        "nested": {
          "displaypermissions": {
            "nested": {
              "PermissionFlag": {
                "values": {
                  "PERMISSION_DO_NOT_USE": 0,
                  "MANAGE_ITEMS": 1,
                  "ISSUE_REFUNDS": 2,
                  "VOID_OPEN_TICKETS": 3,
                  "MANAGE_EMPLOYEES": 4,
                  "MANAGE_DISPUTES": 5,
                  "MANAGE_ORDERS": 11,
                  "VIEW_EXPECTED_IN_DRAWER": 12,
                  "VIEW_DEPOSITS": 13,
                  "ACCESS_SALES_HISTORY": 15,
                  "ACCESS_TERMINAL": 19,
                  "SETTLE_ALL_PAYMENTS_AWAITING_TIP": 21,
                  "RUN_CLOSE_OF_DAY": 22,
                  "REOPEN_CHECKS": 23,
                  "MANAGE_TIMECARDS": 24,
                  "MANAGE_SERVICE_SETTINGS": 25,
                  "MANAGE_RISK_EVALUATION_SETTINGS": 26,
                  "MANAGE_DEVICES": 27,
                  "MANAGE_CUSTOMERS": 28,
                  "MANAGE_INSTRUMENTS_ON_FILE": 29,
                  "MANAGE_APPOINTMENTS_BUSINESS_PROFILE": 30,
                  "MANAGE_SUBSCRIPTIONS": 31,
                  "USE_INVOICES_APPLET": 32,
                  "MANAGE_ALL_OPEN_TICKETS": 33,
                  "MANAGE_ALL_CALENDARS": 34,
                  "OPEN_CASH_DRAWER_OUTSIDE_SALE": 35,
                  "MANAGE_CUSTOMER_IMPORT_EXPORT_AND_CUSTOM_FIELDS": 36,
                  "TOGGLE_OFFLINE_MODE": 37,
                  "EDIT_TAXES_IN_SALE": 38,
                  "EDIT_SURCHARGES_IN_SALE": 40,
                  "MANAGE_CUSTOMER_CAMPAIGNS": 41,
                  "CANCEL_TRANSACTION": 43,
                  "APPLY_RESTRICTED_DISCOUNTS": 44,
                  "ACCESS_APPOINTMENTS": 46,
                  "MANAGE_DEVICE_SECURITY": 47,
                  "MANAGE_RECEIPT_INFORMATION": 48,
                  "MANAGE_TIME_TRACKING_SETTINGS": 49,
                  "MANAGE_HARDWARE_SETTINGS": 50,
                  "MANAGE_CHECKOUT_SETTINGS": 51,
                  "MANAGE_ORDER_SETTINGS": 52,
                  "APP_SIGN_OUT": 55,
                  "CUSTOMIZE_DIRECTORY_OPTIONS": 56,
                  "VIEW_SALES_REPORTING": 58,
                  "VIEW_DETAILED_SALES_REPORTING": 59,
                  "VIEW_CASH_DRAWER_REPORTING": 61,
                  "MANAGE_ITEMS_DASHBOARD": 62,
                  "LEGACY_CHANGE_REGISTER_SETTINGS": 63,
                  "VIEW_INVENTORY_REPORTS": 64,
                  "VIEW_BASIC_SALES_REPORTING": 65,
                  "VIEW_SALES_REPORTING_WITHOUT_DETAILED_REPORTS": 66,
                  "END_TIMECARD_BREAK_EARLY": 67,
                  "VIEW_LOYALTY_REPORTS": 69,
                  "VIEW_LOYALTY_SETTINGS": 70,
                  "UPDATE_LOYALTY_SETTINGS": 71,
                  "MANAGE_LOYALTY_PROMOTIONS": 72,
                  "VIEW_LOYALTY_ACCOUNTS": 73,
                  "UPDATE_LOYALTY_ACCOUNTS": 74,
                  "MANAGE_SCHEDULES": 77,
                  "MANAGE_SCHEDULE_AVAILABILITY": 78,
                  "CUSTOMER_READ": 79,
                  "CUSTOMER_DIRECTORY_ACCESS": 80,
                  "CUSTOMER_INSIGHTS_ACCESS": 81,
                  "CUSTOMER_CONTACT_INFO_READ": 82,
                  "CUSTOMER_CREATE": 83,
                  "CUSTOMER_IMPORT": 84,
                  "CUSTOMER_EXPORT": 85,
                  "CUSTOMER_UPDATE": 86,
                  "CUSTOMER_DELETE": 87,
                  "CUSTOMER_MERGE": 88,
                  "CUSTOMER_BULK": 89,
                  "CUSTOMER_GROUP_READ": 90,
                  "CUSTOMER_GROUP_CREATE": 91,
                  "CUSTOMER_GROUP_UPDATE": 92,
                  "CUSTOMER_GROUP_DELETE": 93,
                  "CUSTOMER_GROUP_MEMBER_ADD_AND_REMOVE": 94,
                  "CUSTOMER_CARDONFILE_READ": 95,
                  "CUSTOMER_CARDONFILE_CREATE": 96,
                  "CUSTOMER_CARDONFILE_DELETE": 97,
                  "CUSTOMER_CUSTOMFIELD_DEFINITION_READ": 98,
                  "CUSTOMER_CUSTOMFIELD_DEFINITION_CREATE": 99,
                  "CUSTOMER_CUSTOMFIELD_DEFINITION_UPDATE": 100,
                  "CUSTOMER_CUSTOMFIELD_DEFINITION_DELETE": 101,
                  "CUSTOMER_ATTACHMENT_READ": 102,
                  "CUSTOMER_ATTACHMENT_CREATE": 103,
                  "CUSTOMER_ATTACHMENT_UPDATE": 104,
                  "CUSTOMER_ATTACHMENT_DELETE": 105,
                  "CUSTOMER_NOTE_READ": 106,
                  "CUSTOMER_NOTE_CREATE": 107,
                  "CUSTOMER_NOTE_UPDATE": 108,
                  "CUSTOMER_NOTE_DELETE": 109,
                  "CUSTOMER_FILTER_READ": 110,
                  "MANAGE_CONTRACTS": 113,
                  "ACCESS_ONLINE_STORE": 114,
                  "CUSTOMER_FEEDBACK_ACCESS": 115,
                  "CUSTOMER_READ_WITH_P1_PERMISSIONS_BACKFILL": 116,
                  "MANAGE_CUSTOMERS_FOR_OTHER_SERVICES": 117,
                  "CUSTOMER_READ_WITH_OLD_PERMISSION_BACKFILL": 118,
                  "MANAGE_INSTRUMENTS_ON_FILE_FOR_OTHER_SERVICES": 119,
                  "CUSTOMER_CARDONFILE_READ_WITH_OLD_PERMISSION_BACKFILL": 120,
                  "MANAGE_CUSTOMER_IMPORT_EXPORT_AND_CUSTOM_FIELDS_FOR_OTHER_SERVICES": 121,
                  "CUSTOMER_EXPORT_WITH_OLD_PERMISSION_BACKFILL": 122,
                  "ACCESS_MESSENGER": 123,
                  "MANAGE_TIMECARD_ENFORCEMENT_SETTINGS": 124,
                  "MANAGE_SCHEDULE_REQUESTS": 125,
                  "MANAGE_TIMECARD_EDIT_REQUESTS": 126,
                  "MANAGE_COMMISSION_SETTINGS": 127,
                  "MANAGE_SALES_TAX": 128,
                  "MANAGE_TIP_DISTRIBUTION_SETTINGS": 129,
                  "MANAGE_BUYER_SUBSCRIPTIONS": 130,
                  "CUSTOMIZE_NAV_BAR": 131,
                  "MANAGE_INVOICES_PROJECTS_WITH_CONTRACTS": 132,
                  "MANAGE_INVOICES_PROJECTS_WITHOUT_CONTRACTS": 133,
                  "MANAGE_REFERRALS_AND_REWARDS": 134,
                  "CUSTOMER_PAYMENTONFILE_READ": 135,
                  "CUSTOMER_PAYMENTONFILE_CREATE": 136,
                  "CUSTOMER_PAYMENTONFILE_DELETE": 137,
                  "USE_CUSTOM_AMOUNT": 138,
                  "HOUSE_ACCOUNTS_READ": 139,
                  "HOUSE_ACCOUNTS_WRITE": 140,
                  "MANAGE_ONLINE_CHECKOUT": 141,
                  "INVENTORY_COUNTING_UNIT_COST_READ": 142,
                  "INVENTORY_MANAGE_CYCLE_COUNT": 143,
                  "INVENTORY_CONTRIBUTE_FULL_COUNT": 144,
                  "INVENTORY_MANAGE_FULL_COUNT": 145,
                  "MANAGE_FULFILLMENT_PREFERENCES": 146,
                  "MANAGE_COMMISSION_SETTINGS_SHIFTS": 147,
                  "SEE_APPT_PERFORMANCE_REPORTS_PERSONAL": 148,
                  "SEE_APPT_PERFORMANCE_REPORTS": 149,
                  "MANAGE_SHARED_DEVICE_PROFILES_V2": 150,
                  "MANAGE_ANNOUNCEMENTS": 151,
                  "SEND_ANNOUNCEMENTS": 152,
                  "CREATE_NEW_CONVERSATIONS": 153,
                  "MANAGE_CONVERSATIONS": 154,
                  "RENAME_CONVERSATIONS": 155,
                  "MODERATE_CONTENT_AND_CONVERSATIONS": 156,
                  "MANAGE_TEAM_FILES": 157,
                  "MANAGE_TEAM_COMMUNICATION_SETTINGS": 158,
                  "RELEASE_MANAGER_ACCESS": 159,
                  "MANAGE_TEAM_MEMBER_FILES_PERMISSION": 160,
                  "MANAGE_TEAM_MEMBER_FILES": 161,
                  "VIEW_TEAM_MEMBER_FILES": 162,
                  "HR_MANAGER_MANAGE": 163,
                  "ALLOW_EXIT_FROM_BUYER_FACING_SCREEN": 164,
                  "APPOINTMENTS_SERVICE_COST_OVERRIDE": 165,
                  "ALLOW_START_CASH_REPORT": 166,
                  "ALLOW_UPDATE_BALANCE": 167,
                  "ALLOW_UPDATE_CASH_IN_CASH_OUT": 168,
                  "ALLOW_END_CASH_REPORT": 169,
                  "MANAGE_TEAM_MEMBER_ONBOARDING": 170,
                  "SALES_REPORTS_EMAIL_READ": 171,
                  "ALLOW_VIEW_WAGE_INFORMATION": 172,
                  "INVENTORY_CONTRIBUTE_CYCLE_COUNT": 173,
                  "POS_MODE_WRITE": 174,
                  "DEVICE_POS_MODE_WRITE": 175,
                  "ISSUE_UNLINKED_REFUNDS": 176,
                  "VIEW_BASIC_APP_INFO": 177,
                  "ACCESS_DEVELOPER_TOOLS": 178,
                  "VIEW_APP_MARKETPLACE": 179,
                  "MANAGE_APP_MARKETPLACE": 180,
                  "VIEW_DISPUTES": 181,
                  "RESPOND_TO_DISPUTES": 182,
                  "MANAGE_INVENTORY": 183,
                  "MANAGE_ADVANCED_SALES_REPORT_FILTERS": 184,
                  "RUN_SHIFT_REPORT": 185
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionFlag) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PermissionFlag @ squareup/empermissions/displaypermissions/permission_flags.proto at 7:1
 */
export const PermissionFlag = $root.lookupEnum('squareup.empermissions.displaypermissions.PermissionFlag').values;